
export const actions = {
  SET_LOCATION: 'SET_LOCATION',
  UPDATE_TRAVEL_DETAILS: "UPDATE_TRAVEL_DETAILS",
  SET_FLIGHT: 'SET_FLIGHT',
  UPDATE_APPLICANT: 'UPDATE_APPLICANT',
  UPDATE_TRAVEL_PROPOSAL: "UPDATE_TRAVEL_PROPOSAL",
  UPDATE_FLIGHT_PROPOSAL: "UPDATE_FLIGHT_PROPOSAL",
  SET_LOADER: 'SET_LOADER',
  UPDATE_FLIGHT_COVER: "UPDATE_FLIGHT_COVER",
  UPDATE_SELECTED_FEATURES: "UPDATE_SELECTED_FEATURES",
  SET_IS_LOGGEDIN: "SET_IS_LOGGEDIN",
  UPDATE_TRAVEL_QUOTATION: "UPDATE_TRAVEL_QUOTATION",
  UPDATE_Flight_QUOTATION: "UPDATE_Flight_QUOTATION",
  UPDATE_BUNDLE_QUOTATION: "UPDATE_BUNDLE_QUOTATION",
  UPDATE_PROPOSAL_REQUEST: "UPDATE_PROPOSAL_REQUEST",
  UPDATE_IS_WORLD_CUP: "UPDATE_IS_WORLD_CUP",
  UPDATE_TRAVEL_GOOGLE_TAGGING_DATA: "UPDATE_TRAVEL_GOOGLE_TAGGING_DATA",
  UPDATE_BUSINESSLINE: "UPDATE_BUSINESSLINE",
  UPDATE_QUOTATION: "UPDATE_QUOTATION",
}


export const setLoading = (payload) => {
  return {
    type: actions.SET_LOADER,
    payload: payload
  };
};

export const updateApplicant = (applicant) => {
  return {
    type: actions.UPDATE_APPLICANT,
    payload: applicant
  }
}

export const updateTravelDetails = (payload) => {
  return {
    type: actions.UPDATE_TRAVEL_DETAILS,
    payload
  }
};

export const updateTravelProposal = (payload) => {
  return {
    type: actions.UPDATE_TRAVEL_PROPOSAL,
    payload
  }
};
export const updateFlightProposal = (payload) => {
  return {
    type: actions.UPDATE_FLIGHT_PROPOSAL,
    payload
  }
};


export const updateFlightCover = (payload) => {
  return {
    type: actions.UPDATE_FLIGHT_COVER,
    payload
  }
}

export const updateSelectedFeatures = (payload) => {
  return {
    type: actions.UPDATE_SELECTED_FEATURES,
    payload
  }
};

export const setIsLoggedIn = (payload) => {
  return {
    type: actions.SET_IS_LOGGEDIN,
    payload
  };
};

export const updateTravelQuotation = (payload) => {
  return {
    type: actions.UPDATE_TRAVEL_QUOTATION,
    payload
  };
};

export const updateFlightQuotation = (payload) => {
  return {
    type: actions.UPDATE_Flight_QUOTATION,
    payload
  };
};

export const updateBundleQuotation = (payload) => {
  return {
    type: actions.UPDATE_BUNDLE_QUOTATION,
    payload
  };
};

export const updateProposalRequest = (payload) => {
  return {
    type: actions.UPDATE_PROPOSAL_REQUEST,
    payload
  };
};

export const updateIsWorldCup = (payload) => {
  return {
    type: actions.UPDATE_IS_WORLD_CUP,
    payload
  }
}

export const updateTravelGoogleTaggingData = (payload) => {
  return {
    type: actions.UPDATE_TRAVEL_GOOGLE_TAGGING_DATA,
    payload
  }
}

export const updateBusinessLine = (payload) => {
  return {
    type: actions.UPDATE_BUSINESSLINE,
    payload
  }
}

export const UpdateQuotation = (data) => {
  return {
    type: actions.UPDATE_QUOTATION,
    payload: data,
  };
};

export const updateLoggedInUser = data => ({
  type: actions.UPDATE_USER_LOGGED_IN,
  payload: data
});